import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  PromiseResult,
  toPromise,
} from '@fc-shared/utils/request-utils/toPromise';
import { AttachmentModel } from '@fc-vehicles/service/attachment-model';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FileCategory } from '../models/FileCategories';

@Injectable({
  providedIn: 'root',
})
export class FilesApiService {
  private readonly http = inject(HttpClient);
  private readonly url = `${environment.apiUrl}api/files/`;

  deleteFile(fileId: number): PromiseResult<void> {
    return toPromise(this.http.delete<void>(`${this.url}${fileId}/`));
  }

  renameFile(fileId: number, name: string): PromiseResult<AttachmentModel> {
    return toPromise(
      this.http.patch<AttachmentModel>(`${this.url}${fileId}/`, { name }),
    );
  }

  createFileSlot(category: FileCategory): Promise<AttachmentModel> {
    return lastValueFrom(
      this.http.post<AttachmentModel>(this.url, { category }),
    );
  }

  getFile(fileId: number): Promise<AttachmentModel> {
    return lastValueFrom(
      this.http.get<AttachmentModel>(`${this.url}${fileId}/`),
    );
  }
}
